module.exports = __webpack_public_path__ + "img/zoom-in.25526cd6.svg";